export const isProduction = process.env.NODE_ENV === 'production'

export const AWS_RED_BUTTON_API = process.env.REACT_APP_AWS_RED_BUTTON_API

export type FirebaseConfig = {
  apiKey: string
  authDomain: string
  databaseURL: string
  projectId: string
  storageBucket: string
  messagingSenderId: string
  appId: string
  measurementId: string
}
export type Configuration = {
  isWecRedbutton: boolean
}

export const firebaseConfig: FirebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
  databaseURL: process.env.REACT_APP_FIREBASE_DB_URL || '',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MSG_SENDER_ID || '',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || '',
}

export const config: Configuration = {
  isWecRedbutton:
    process.env.REACT_APP_FIREBASE_PROJECT_ID === 'fia-wec-production',
}
export const FIREBASE_CONFIG = firebaseConfig
